import React from "react";

export default function AboutSection() {
  return (
    <section
      id="about"
      className="py-20 bg-slate-950 text-white relative overflow-hidden"
    >
      <div className="absolute inset-x-0 -top-24 h-40 bg-gradient-to-b from-white/10 to-transparent pointer-events-none" />

      <div className="max-w-6xl mx-auto px-4 md:px-8 relative">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div className="animate-fade-up">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              We turn moments into{" "}
              <span className="text-[#E34364]">shareable stories.</span>
            </h2>
            <p className="text-gray-200 mb-3">
              At PixlyBooth, we turn ordinary moments into extraordinary memories.
              Whether it’s a wedding, corporate event, birthday, or brand activation,
              our photo booths are designed to engage, entertain, and instantly share
              the fun.
            </p>
            <p className="text-gray-300">
              We combine sleek design, cutting-edge technology, and a splash of
              creativity to make every event picture-perfect.
            </p>

            <div className="mt-6 grid grid-cols-2 gap-4 text-sm">
              <div className="bg-white/5 border border-white/10 rounded-2xl p-4">
                <div className="text-2xl mb-1">📸</div>
                <div className="font-semibold">Modern Booths</div>
                <div className="text-gray-300">
                  Open air, 360°, glam & more — tailored to your vibe.
                </div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-4">
                <div className="text-2xl mb-1">⚡</div>
                <div className="font-semibold">Instant Sharing</div>
                <div className="text-gray-300">
                  Guests receive their photos & videos within seconds.
                </div>
              </div>
            </div>
          </div>

          <div className="animate-fade-up md:translate-y-4 md:delay-150">
            <div className="rounded-3xl bg-gradient-to-br from-[#E34364]/30 via-purple-800/50 to-slate-950 p-[1px] shadow-2xl">
              <div className="rounded-3xl bg-slate-900/90 p-6 md:p-7">
                <h3 className="text-lg font-semibold mb-4">
                  Perfect for every occasion
                </h3>
                <ul className="space-y-3 text-gray-200 text-sm">
                  <li className="flex items-start gap-2">
                    <span className="mt-[3px] text-[#E34364]">●</span>
                    Weddings & private parties
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-[3px] text-[#E34364]">●</span>
                    Corporate events & holiday celebrations
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-[3px] text-[#E34364]">●</span>
                    Product launches & brand activations
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-[3px] text-[#E34364]">●</span>
                    Nightlife events, festivals & more
                  </li>
                </ul>

                <div className="mt-6 text-xs text-gray-400 border-t border-white/10 pt-4">
                  We bring the booth, props, lighting, attendant, and instant
                  sharing — you just bring the guests.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
